import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-info">
            <h3>Shamshersons Quality Piano Works</h3>
            <p>
              With the experience of nearly a century, we promise to provide our
              best services and expertise in a professional way.
            </p>
          </div>

          <div className="footer-contact">
            <h4>Contact Us</h4>
            <p>
              <strong>Phone:</strong> +91 9811020513, +91 9810427172
            </p>
            <p>
              <strong>Email:</strong> shamshersons@yahoo.co.in
            </p>
            <p>
              <strong>Address:</strong> 100, Ram Nagar Market, Qutab Road,
              Opposite Hotel Tourist, Pahar Ganj, New Delhi-110055
            </p>
          </div>

          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about-us">About Us</Link>
              </li>
              <li>
                <Link to="/services">Services</Link>
              </li>
              <li>
                <Link to="/achievements">Achievements</Link>
              </li>
              <li>
                <Link to="/about-pianos">About Pianos</Link>
              </li>
              <li>
                <Link to="/enquiry">Contact Us</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            &copy; {currentYear} Shamshersons Quality Piano Works. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
